/* eslint-disable react/jsx-no-target-blank */
import 'moment/locale/pt-br';
import Moment from 'react-moment';
import { useState } from 'react';
import api from '../../../services/api';
import {comum} from "../../../styles/Themes/light";
import {IconAttachment, IconDownload, IconUpload} from "../../icons";
import {WrapperFiles} from "./styles";
import toastservice from '../../../services/toast';
import { Loader2 } from 'lucide-react';
import toast from 'react-hot-toast';
import { toastDefsError } from '../../../config/toastConfig';
import { formatFileSize } from '../../../utility/byteSizeUtils';

interface FileProps {
    title?: string,
    files?: any,
    edit?: any,
    sendFiles?: any,
    hideDate?: boolean,
    limitNameFile?: number,
    isUploadingFiles?: boolean,
    arquivosEnviando?: File[],
    id_proposta?: number | null,
}

export default function DemandFiles({title, files, edit, sendFiles, hideDate, limitNameFile = 38, isUploadingFiles, arquivosEnviando, id_proposta = null}: FileProps) {
    
    const [downloadingFiles, setDownloadingFiles] = useState<Set<string>>(new Set());
    
    const normalizeFilePath = (caminho: string, idProposta: number | null): string => {
        if (!caminho || caminho.trim() === '') {
            return caminho;
        }
        if (caminho.includes('/')) {
            return caminho;
        }
        if (idProposta) {
            return `${idProposta}/${caminho}`;
        }
        return caminho;
    };

    const extrairCaminho = (row: any): string => {
        const isString = typeof row === 'string';
        const caminhoPrimario = isString ? row : row?.caminho;
        const caminhoSecundario = !isString && row?.pasta && row?.arquivo ? `${row.pasta}/${row.arquivo}` : (!isString && typeof row?.arquivo === 'string' ? row.arquivo : '');
        return typeof caminhoPrimario === 'string' && caminhoPrimario.length > 0 ? caminhoPrimario : caminhoSecundario;
    };

    const handleDownload = async (caminhoNormalizado: string, nomeArquivo: string) => {
        const fileKey = caminhoNormalizado;
        
        if (downloadingFiles.has(fileKey)) {
            return;
        }

        setDownloadingFiles(prev => new Set(prev).add(fileKey));
        
        try {
            const pathSegments = caminhoNormalizado.split('/').map(segment => encodeURIComponent(segment));
            const downloadPath = 'getfile/' + pathSegments.join('/');
            await api.download(downloadPath, nomeArquivo);
        } catch (error: any) {
            if (error.response?.status === 404) {
                toast.error('O arquivo não se encontra no sistema, entre em contato com o operador', {
                    ...toastDefsError,
                    duration: 5000,
                });
            } else {
                toastservice.error('Erro ao baixar o arquivo. Por favor, tente novamente mais tarde.');
            }
        } finally {
            setDownloadingFiles(prev => {
                const newSet = new Set(prev);
                newSet.delete(fileKey);
                return newSet;
            });
        }
    };

    return (
        <WrapperFiles>
            <span>{title ? title : 'Arquivos:'}</span>
            {
                arquivosEnviando && arquivosEnviando.length > 0 &&
                arquivosEnviando.map((file, index) => (
                    <div className="loading-file" key={`loading-${index}`}>
                        <div className="loading-file-info">
                            <div className="loading-file-name">{file.name}</div>
                            <div className="loading-file-size">{formatFileSize(file.size)}</div>
                        </div>
                        <div className="loading-spinner">
                            <div className="spinner" />
                        </div>
                    </div>
                ))
            }
            {
                (!files || files.length === 0) && (!arquivosEnviando || arquivosEnviando.length === 0) &&
                <div className="file">Sem arquivos anexados</div>
            }
            {
                files?.length > 0 &&
                files.map((row: any, index: number) => {
                    const isString = typeof row === 'string';
                    const caminho = extrairCaminho(row);
                    const key = `${(row && row.id) || caminho || 'file'}-${index}`;
                    const caminhoNormalizado = caminho.includes('/') 
                        ? caminho 
                        : normalizeFilePath(caminho, id_proposta);
                    const dataArquivo = (!isString && (row.criado || row.modificado || row.data)) || null;
                    const somenteNome = caminhoNormalizado.split('/').filter(Boolean).pop() || caminhoNormalizado;
                    const fileKey = caminhoNormalizado;
                    const isDownloading = downloadingFiles.has(fileKey);
                    
                    return (
                    <div className={!isString && row.arquivo_final === 'sim' ? 'file last' : 'file'} key={key}>
                        <div className="file-details">
                            <div className="icon-title">
                                <div className="icon-file">
                                    <IconAttachment color={comum.colors.interfaceGray400}/>
                                </div>
                                <div className="title-file">
                                    {somenteNome.length > limitNameFile ? somenteNome.substring(0, limitNameFile) + '...' : somenteNome}
                                </div>
                            </div>
                            {
                                !hideDate && dataArquivo &&
                                <div className="date"><Moment locale='pt-br' format="DD/MM/YYYY">{dataArquivo}</Moment></div>
                            }
                        </div>
                        <div className="download" onClick={() => handleDownload(caminhoNormalizado, somenteNome)}>
                            {isDownloading ? (
                                <Loader2 size={20} color={comum.colors.interfaceGray400} className="spinner" />
                            ) : (
                                <IconDownload />
                            )}
                        </div>
                    </div>
                    )
                })
            }
            {
                edit &&
                <div className="add">
                    <IconUpload />
                    <input
                        type="file"
                        name="Files"
                        className="file-input"
                        onChange={sendFiles}
                    />
                </div>
            }

        </WrapperFiles>
    )
}
